import { ethers } from "ethers";
import NFTAbi from "./flokiAbi.json";
import NFTStakingABI from "./stakingContractAbi.json";

export const inProduction = true;

export const StakingContractAddress = inProduction
  ? "0x3fB711e7180ebAB90c455a5Bc03f99766460f133"
  : "0x2Fd377C2b1Ca8e3bec883AB967ffdCEb9CcA0702";

export const NFTContractAddress = inProduction
  ? "0xAF3044f6C25245e4dA3824f0dD461C950D439335"
  : "0x36756829deF4F9D6Cd74770B4A23Cb1A9dD673B2";

let signer;
if (window.ethereum !== undefined) {
  const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
  signer = provider.getSigner();
}

export const nftContract = new ethers.Contract(
  NFTContractAddress,
  NFTAbi,
  signer
);
export const nftStakingContract = new ethers.Contract(
  StakingContractAddress,
  NFTStakingABI,
  signer
);
